import React from 'react';
import cN from 'classnames';
import styles from './styles.module.scss';

interface I_SearchSkeletonProps {
    part: 'filter' | 'cards' | 'rectangle';
    device?: 'pc' | 'm';
    customClassName?: string;
}

const Skeleton = (props: I_SearchSkeletonProps) => {
    const { part, device, customClassName } = props;
    if (part === 'filter') {
        return (
            <div className={styles.filtersSkeleton}>
                <div className={styles.blockSkeleton}>
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                </div>
                <div className={styles.divideBlock} />
                <div className={styles.blockSkeleton}>
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                    <div className={styles.bar} />
                </div>
            </div>
        );
    }

    if (part === 'cards' && device) {
        return device === 'pc' ? (
            <div className={styles.cardsSkeleton}>
                {Array.from(Array(6)).map((_, i) => (
                    <div className={styles.cardSkeleton_pc} key={i}>
                        <div className={styles.square} />
                        <div className={styles.contentBars}>
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                        </div>
                        <div className={styles.btnBars}>
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <div className={styles.cardsSkeleton}>
                {Array.from(Array(4)).map((_, i) => (
                    <div className={styles.cardSkeleton_m} key={i}>
                        <div className={styles.contentBars}>
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                        </div>
                        <div className={styles.btnBars}>
                            <div className={styles.bar} />
                            <div className={styles.bar} />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (part === 'rectangle') {
        return (
            <div className={cN(styles['rectangleSkeleton'], customClassName && styles[customClassName])}>
                <div className={styles['rectangle']} />
            </div>
        );
    }

    return <div />;
};

export default Skeleton;
